<template>
  <div class="incorrect-amount">
    <h2 class="normal" v-html="$t('confirmation.incorrectAmount.header')"></h2>
    <p v-html="$t('confirmation.incorrectAmount.description')"></p><p v-html="$t('confirmation.incorrectAmount.description2')"></p>
  </div>
</template>
<script>
export default {
  name: 'ConfirmationIncorrectAmount'
}
</script>
